type Props = {
  muted: boolean; onToggle: () => void
  playing: boolean; onTogglePlayback: () => void
  controlsVisible: boolean; onToggleControls: () => void; ready: boolean
}

export default function VideoSoundControl({ muted, onToggle, playing, onTogglePlayback, controlsVisible, onToggleControls, ready }: Props) {
  return <div className="video-controls-group">
    <div className="video-controls-bar">
      <button type="button" className="video-action-control" onClick={onTogglePlayback} aria-label={playing ? 'หยุดวิดีโอชั่วคราว' : 'เล่นวิดีโอ'}>
        <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">{playing ? <><rect x="6" y="5" width="4" height="14" rx="1" /><rect x="14" y="5" width="4" height="14" rx="1" /></> : <path d="M8 5v14l11-7Z" />}</svg>
      </button>
      <button type="button" className="video-sound-control" onClick={onToggle} aria-label={muted ? 'เปิดเสียงวิดีโอ' : 'ปิดเสียงวิดีโอ'}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M11 5 6 9H3v6h3l5 4V5Z" />{muted ? <path d="m16 9 5 6m0-6-5 6" /> : <><path d="M15 8a6 6 0 0 1 0 8" /><path d="M18 5a10 10 0 0 1 0 14" /></>}</svg>
        <span>{muted ? 'แตะเปิดเสียง' : 'ปิดเสียง'}</span>
      </button>
      <button type="button" className="video-action-control" onClick={onToggleControls} disabled={!ready} aria-expanded={controlsVisible}
        aria-label={controlsVisible ? 'ซ่อนแถบเลื่อนและปุ่มเต็มจอ' : 'แสดงแถบเลื่อนและปุ่มเต็มจอ'} title="แถบเลื่อนและเต็มจอ">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" aria-hidden="true"><path d="M4 7h16M4 17h16" /><circle cx="9" cy="7" r="2" fill="currentColor" /><circle cx="15" cy="17" r="2" fill="currentColor" /></svg>
      </button>
    </div>
    {muted && <p className="video-sound-hint">เว็บจะจำการเลือกเสียงสำหรับคลิปถัดไป</p>}
  </div>
}
